import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../store';
import {setExplainActive, showVersionNotice} from '../slices/statusSlice';
import close from '../../icons/close';
import {selectFinalized, selectSpcSession} from '../selectors';

@customElement('version-notice')
export class VersionNotice extends connect(store)(LitElement) {

	static styles = css`
		:host {
			z-index: 110;
		}

		@keyframes reveal {
			from {
				opacity: 0;
			}

			to {
				opacity: 100%;
			}
		}
		@keyframes slide {
			from {
				transform: translateY(100px);
			}

			to {
				transform: translateY(0px);
			}
		}

		.modal {
			position: absolute;
			height: 100%;
			width: 100%;
			left: 0;
			top: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: var(--color-black-transparent);
			opacity: 100%;
			animation: reveal 0.25s ease-out normal forwards;
		}

		p {
			font: var(--font-light);
		}

		.close {
			flex-basis: 0;
			color: var(--color-black);
			background-color: transparent;
			border: none;
			cursor: pointer;
			height: 20px;
		}

		.close svg {
			pointer-events: none;
		}

		.close svg * {
			stroke: currentColor;
		}

		.panel {
			padding: var(--large-padding);
			background-color: var(--color-grey1);
			width: 50vw;
			animation: slide 0.25s ease-out normal forwards;
			display: flex;
			flex-direction: row;
			gap: var(--large-padding);
		}

		.content {
			overflow-y: auto;
			height: 100%;
			flex-basis: 100%;
			font: var(--font-light);

		}


		button {
			font-family: var(--font-family-light);
			font-size: var(--font-size-widget);
			color: #000;
			height: var(--height-widget);
			border: 1px solid #000;
			text-transform: uppercase;
			letter-spacing: 1px;
			transition: background-color 0.4s, color 0.4s;
			background-color: transparent;
			cursor: pointer;
			line-height: 0;
			flex-basis: 50%
		}

		button.ok {
			background-color: #000;
			color: #fff;
		}

		@media (max-width: 768px) {
			.panel {
				width: 100vw;
				flex-direction: column;
			}

			.content {
				flex-basis: 100%;
			}

			.title {
				flex-basis: 0;
			}

			.close {
				position: absolute;
				top: var(--large-padding);
				right: var(--large-padding);
			}
		}

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.status = state.status;
		this.showVersionNotice = this.status.showVersionNotice;
		this.isFinalized = selectFinalized(state);
		this.versionNotice = this.status.versionNotice;
		this.lang = state.status.lang;
	}

	connectedCallback() {
		super.connectedCallback();
		addEventListener('keydown', this.handleKeydown);
	}

	handleKeydown = (e) => {
		switch (e.keyCode) {
			case 27: // ESC
				if (this.explainActive) {
					this.close();
				}
				break;
		}
	};

	close(e) {
		store.dispatch(showVersionNotice(
			{
				active: false,
			}
		));
	}

	render() {
		return (this.showVersionNotice && !this.isFinalized) ? html`
			<div id="modal" class="modal" @click="${this.close}">
				<div class="panel">
					<div class="content">
						<h2>
							${msg('This configuration is based on an older data set. The loaded properties are displayed correctly if possible, but they may by incomplete. Please check and reconfigure if necessary.')}
						</h2>
						<div class="buttons">
							<button class="ok" @click="${this.close}">
								${msg('close')}
							</button>
						</div>
					</div>
					<button id="close" @click="${this.close}" class="close">
						${close}
					</button>
				</div>
			</div>
		` : null;
	}
}
